import React, { useState, useEffect } from "react";

import "./createevent.css";
import { LEGACY_IMAGE_OPTIONS } from "./legacyImageOptions";
import EventImagePicker from "./EventImagePicker/EventImagePicker";
import { searchLocations } from "../../../api/eventLocations";

const CreateEvent = () => {
  const [title, setTitle] = useState("");
  // Get current date in US Eastern Time and set time to 6 PM
  const easternTime = new Date().toLocaleString("en-US", {
    timeZone: "America/New_York",
  });
  const defaultDateTime = new Date(easternTime);
  defaultDateTime.setHours(18, 0, 0, 0); // Set time to 6 PM
  const [dateTime, setDateTime] = useState(defaultDateTime.toISOString());
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [length, setLength] = useState("");
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [locationSearch, setLocationSearch] = useState("");
  const [apiLocations, setApiLocations] = useState([]);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [previousEvents, setPreviousEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [password, setPassword] = useState("d");
  const [generalPublic, setGeneralPublic] = useState(true);
  const [membersOnly, setMembersOnly] = useState(true);
  const [pollPrivateLocation, setPollPrivateLocation] = useState("TBD");
  const [pollText, setPollText] = useState("TBD");
  const [hostName, setHostName] = useState("");
  const [yourName, setYourName] = useState("");
  const [yourPhoneNumber, setYourPhoneNumber] = useState("");
  const [chat, setChat] = useState("Other Events");
  const [groupmeImg, setGroupmeImg] = useState("https://i.groupme.com/1904x1428.jpeg.842ce8ff2bc648738d8b3d0fb25f6435.large");
  const [groupMeChatUrl, setGroupMeChatUrl] = useState("");
  const [groupMeChatId, setGroupMeChatId] = useState("");
  const [imgKey, setImgKey] = useState("main/concert_001.jpg");
  const [showAdvancedFields, setShowAdvancedFields] = useState(false);

  const groupMeImageOptions = [
    {
      path: "https://i.groupme.com/1904x1428.jpeg.842ce8ff2bc648738d8b3d0fb25f6435.large",
      alias: "Generic Event",
    },
    {
      path: "https://i.groupme.com/924x2000.png.f266293f8b4f4926b5486d681bbf45ea",
      alias: "Run Group",
    },
    {
      path: "https://i.groupme.com/3072x1778.jpeg.6265c17478974308956891e2d178588e",
      alias: "Pickleball",
    },
    {
      path: "https://i.groupme.com/1204x1600.jpeg.170ab56cee98483caaeb32c81f31aab3",
      alias: "Volleyball",
    },
    { path: "https://i.groupme.com/2034x1040.jpeg.72dec320e0b24c28b5ee56b692884f9d.large", 
      alias: "Volleyball 2" 
    },
    // rock gym
    {
      path: "https://i.groupme.com/1536x2048.png.2a7d774a64174901a1e011f505cd7d03",
      alias: "Rock Gym",
    },
    { path: "https://i.groupme.com/1536x1069.jpeg.538d67196b4840d496112c5f21c8004b.large", 
      alias: "Rock Gym 2" },
    // spanish
    {
      path: "https://i.groupme.com/1600x1066.jpeg.262980df512a4ad2a577cc89197912ea.large",
      alias: "Spanish Conversation",
    },
    {
      path: "https://i.groupme.com/1079x1104.png.ae63983e9a59438cbed3777efa7964e8.large",
      alias: "Beach Hangout"
    },
    {
      path: "https://i.groupme.com/1368x1824.jpeg.18c0068121c845388b1b7fcab6badafa.large",
      alias: "Coffee Shop"
    },
  ];

  const locationOptions = [
    {
      value: "Jarboe Park, 510 Florida Blvd, Neptune Beach, FL 32266",
      alias: "Jarboe Park",
    },
    {
      value: "Margaritaville, 715 1st St N, Jacksonville Beach, FL 32250",
      alias: "Margaritaville Jax Beach",
    },
    {
      value: "Veterans Park, 1332 Veterans Pkwy, St Johns, FL 32259",
      alias: "Veterans Park",
    },
    {
      value: "K1 Speed, 6601 Executive Park Ct N, Jacksonville, FL 32216",
      alias: "K1 Speed",
    },
    {
      value: "Fort Family Park, 8000 Baymeadows Rd E, Jacksonville, FL 32256",
      alias: "Fort Family Park",
    },
    {
      value:
        "Florida Blvd Beach Access, 100 Florida Blvd, Neptune Beach, FL 32266",
      alias: "Florida Blvd Beach Access",
    },
    {
      value: "1937 Spirits & Eatery, 1842 Kings Ave, Jacksonville, FL 32207",
      alias: "1937 Spirits & Eatery",
    },
    {
      value: "Aardwolf Brewing Co, 1461 Hendricks Ave, Jacksonville, FL 32207",
      alias: "Aardwolf Brewing Co",
    },
    {
      value: "Alien Taco, 7643 Gate Pkwy, Jacksonville, FL 32256",
      alias: "Alien Taco",
    },
    {
      value: "Artessence Coffee Shop, 1505 N Main St, Jacksonville, FL 32206",
      alias: "Artessence Coffee Shop",
    },
    {
      value: "Beaches Rock Gym, 14 W 3rd St, Atlantic Beach, FL 32233",
      alias: "Beaches Rock Gym",
    },
    {
      value: "Church of Eleven22, 14286 Beach Blvd, Jacksonville, FL 32250",
      alias: "Church of Eleven22",
    },
    {
      value: "Cuisine 76 and Bar, 1023 Park St, Jacksonville, FL 32204",
      alias: "Cuisine 76 and Bar",
    },
    {
      value:
        "Culhane's Irish Pub: Southside, 9720 Deer Lake Court, Jacksonville, FL",
      alias: "Culhane's Irish Pub: Southside",
    },
    {
      value: "Edge Rock Gym, 3563 Philips Hwy #702, Jacksonville, FL 32207",
      alias: "Edge Rock Gym",
    },
    {
      value: "F45 Baymeadows, 8738 Baymeadows Rd E, Jacksonville, FL 32256",
      alias: "F45 Baymeadows",
    },
    {
      value:
        "First Christian Church of the Beaches, 2125 Ocean Front, Neptune Beach, FL 32266",
      alias: "First Christian Church of the Beaches",
    },
    {
      value:
        "Fishweir Brewing Company, 1183 Edgewood Avenue S, Jacksonville, FL US 32205",
      alias: "Fishweir Brewing Company",
    },
    {
      value: "Flynn Park, 2738 Orange Picker Rd, Jacksonville, FL 32223",
      alias: "Flynn Park",
    },
    {
      value: "Georgia Nick Gallery, 11 A Aviles St, St. Augustine, FL 32084",
      alias: "Georgia Nick Gallery",
    },
    {
      value: "Ginnie Springs, 7300 NE Ginnie Spgs Rd, High Springs, FL 32643",
      alias: "Ginnie Springs",
    },
    {
      value: "Green Room Brewing, 228 3rd St N, Jacksonville Beach, FL 32250",
      alias: "Green Room Brewing",
    },
    {
      value:
        "Greenwise Publix at Nocatee, 250 Pine Lake Dr, Ponte Vedra Beach, FL 32081",
      alias: "Greenwise Publix at Nocatee",
    },
    {
      value: "Jax Beach Pier, Jacksonville Beach, FL",
      alias: "Jax Beach Pier",
    },
    {
      value: "Jekyll Brewery",
      alias: "Jekyll Brewery",
    },
    {
      value: "Lemon Bar, 2 Lemon St, Neptune Beach, FL 32266",
      alias: "Lemon Bar",
    },
    {
      value: "Main Event, 10370 Philips Hwy, Jacksonville, FL 32256",
      alias: "Main Event",
    },
    {
      value: "Metropolitan Park, 64 Gator Bowl Blvd, Jacksonville, FL 32202",
      alias: "Metropolitan Park",
    },
    {
      value:
        "Mickler's Landing Beach Parking, County Rd 203, Ponte Vedra Beach, FL 32082",
      alias: "Mickler's Landing Beach Parking",
    },
    {
      value: "Myrtle Avenue Brewing, 633 Myrtle Ave N, Jacksonville, FL",
      alias: "Myrtle Avenue Brewing",
    },
    {
      value:
        "Nocatee Fields, 707 Little River Rd., Ponte Vedra Beach, FL 32081",
      alias: "Nocatee Fields",
    },
    {
      value: "Ocean City Church, 102 6th Ave N, Jacksonville Beach, FL 32250",
      alias: "Ocean City Church",
    },
    {
      value:
        "Oceanfront Park (between 5th & 6th Ave S in Jax Beach), 429 1st St S, Jacksonville Beach, FL 32250",
      alias: "Oceanfront Park (between 5th & 6th Ave S in Jax Beach)",
    },
    {
      value: "One Ocean Resort & Spa, 1 Ocean Blvd, Atlantic Beach, FL",
      alias: "One Ocean Resort & Spa",
    },
    {
      value: "Pete's Bar, 117 First St, Neptune Beach, FL 32266",
      alias: "Pete's Bar",
    },
    {
      value:
        "Publix Greenwise Market, 250 Pine Lake Dr, Ponte Vedra Beach, FL 32081",
      alias: "Publix Greenwise Market",
    },
    {
      value:
        "Recreation and Wellness, 1 UNF Dr. Bldg 61, Rm 1200, Jacksonville, FL 32224",
      alias: "Recreation and Wellness",
    },
    {
      value: "Ruby Beach Brewing, 228 E Forsyth St, Jacksonville, FL 32202",
      alias: "Ruby Beach Brewing",
    },
    {
      value: "Sadler Ranch, 869 Sadler Rd st. 2, Fernandina Beach, FL 32034",
      alias: "Sadler Ranch",
    },
    {
      value: "Sago Coffee, 318 7th Ave N, Jacksonville Beach, FL 32250",
      alias: "Sago Coffee",
    },
    {
      value: "Seawalk Pavilion, 75 1st Street, Jacksonville Beach, FL",
      alias: "Seawalk Pavilion",
    },
    {
      value:
        "Southern Swells Brewing, 1312 Beach Blvd, Jacksonville Beach, FL 32250",
      alias: "Southern Swells Brewing",
    },
    {
      value:
        "Spirit Halloween (Mandarin), 12200 San Jose Blvd #12, Jacksonville, FL 32223",
      alias: "Spirit Halloween (Mandarin)",
    },
    {
      value: "Spring Park, 229 Walnut St, Green Cove Springs, FL 32043",
      alias: "Spring Park",
    },
    {
      value:
        "St Augustine Art Association, 22 Marine Street, St Augustine, FL 32084",
      alias: "St Augustine Art Association",
    },
    {
      value:
        "St Johns County Pavilion, 350 A1A Beach Blvd, St. Augustine, FL 32080",
      alias: "St Johns County Pavilion",
    },
    {
      value:
        "St. Augustine Beach Art Studio, 370A A1A Beach Blvd, St Augustine Beach, FL 32080",
      alias: "St. Augustine Beach Art Studio",
    },
    {
      value: "Stone Climbing, 115 Strongway Ct, St. Augustine, FL 32086",
      alias: "Stone Climbing",
    },
    {
      value:
        "Sur Southside Quarter Apartments, 7385 Park Village Drive, Jacksonville, FL 32256",
      alias: "Sur Southside Quarter Apartments",
    },
    {
      value: "Surfer Bar, 200 1st St N, Jacksonville Beach, FL 32250",
      alias: "Surfer Bar",
    },
    {
      value: "The Dance Shack, 3837 Southside Blvd, Jacksonville, FL 32216",
      alias: "The Dance Shack",
    },
    {
      value:
        "The Pub on Anastasia, 213 Anastasia Blvd, St. Augustine, FL 32080",
      alias: "The Pub on Anastasia",
    },
    {
      value:
        "The Wreck Tiki Lounge, 108 3rd Ave N, Jacksonville Beach, FL 32250",
      alias: "The Wreck Tiki Lounge",
    },
    {
      value:
        "Trader Joe's Jax Beach, 4180 3rd St S, Jacksonville Beach, FL 32250",
      alias: "Trader Joe's Jax Beach",
    },
    {
      value: "UNF Driving Range, 1 Betty Holzendorf Dr, Jacksonville, FL 32224",
      alias: "UNF Driving Range",
    },
    {
      value: "UNF Lot 18, Jacksonville, FL 32224",
      alias: "UNF Lot 18",
    },
  ];

  const chatOptions = [
    { value: "Pickleball", alias: "Pickleball" },
    { value: "Volleyball", alias: "Volleyball" },
    { value: "Yoga, Runs, Workouts", alias: "Yoga, Runs, Workouts" },
    { value: "Dance", alias: "Dance" },
    { value: "Rock Climbing", alias: "Rock Climbing" },
    { value: "Other Events", alias: "Other Events" },

    // { value: "Spanish Conversation", alias: "Spanish Conversation" },
    // { value: "Golf Driving Range", alias: "Golf Driving Range" },
    // { value: "Beach Worship or Church", alias: "Beach Worship or Church" },
    // { value: "Art Walk", alias: "Art Walk" },
  ];

  useEffect(() => {
    // Fetch previous events from the API using PUT request
    const fetchPreviousEvents = async () => {
      const response = await fetch(
        "https://4cljs7mcdi.execute-api.us-east-1.amazonaws.com/default/socialevents",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            /* your PUT request payload here */
          }),
        }
      );
      const data = await response.json();
      const sortedEvents = data.socialEvents.sort((a, b) =>
        b.socialEventId.localeCompare(a.socialEventId)
      );
      setPreviousEvents(sortedEvents);
    };

    fetchPreviousEvents();
  }, []);

  // Debounced API search for locations. Hits the event-locations API when the
  // popup is open. The hardcoded `locationOptions` array remains a fallback
  // when the API is unconfigured / returns no hits.
  useEffect(() => {
    if (!showLocationModal) {
      return undefined;
    }
    const q = (locationSearch || "").trim();
    let cancelled = false;

    const doSearch = () => {
      searchLocations(q)
        .then((resp) => {
          if (cancelled) return;
          setApiLocations(
            Array.isArray(resp && resp.results) ? resp.results : []
          );
        })
        .catch((err) => {
          if (cancelled) return;
          // eslint-disable-next-line no-console
          console.warn("Location search failed:", err);
          setApiLocations([]);
        });
    };

    // No debounce when search is empty — show favorites + recent locations
    // immediately on modal open and when the user clears the box.
    if (!q) {
      doSearch();
      return () => {
        cancelled = true;
      };
    }

    // Typed queries debounce 300ms.
    const handle = setTimeout(doSearch, 300);
    return () => {
      cancelled = true;
      clearTimeout(handle);
    };
  }, [showLocationModal, locationSearch]);

  const handleEventSelect = (eventId) => {
    const event = previousEvents.find((e) => e.socialEventId === eventId);
    if (event) {
      setTitle(event.title);
      // set setPollText to first 15 chars of title if it's not null, otherwise set it to null
      setPollText(event.title ? event.title.slice(0, 15) : null);
      setDateTime(new Date(event.date).toISOString());
      setLocation(event.location);
      // use first 15 chars of pollPrivateLocation if it's not null, otherwise set it to null
      setPollPrivateLocation(
        event.pollPrivateLocation
          ? event.pollPrivateLocation.slice(0, 15)
          : null
      );
      setDescription(event.description);
      setLength(event.length);
      setSelectedEvent(event);
      setChat(event.chat);
      setGroupmeImg(event.groupmeImg);
      setGroupMeChatUrl(event.groupMeChatUrl);
      setGroupMeChatId(event.groupMeChatId);
      setImgKey(event.imgKey);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission here
    // split datetime into date and time
    let date = dateTime.split("T")[0];
    let time = dateTime.split("T")[1];
    // Remove seconds
    time = time.slice(0, 5);
    // Convert "18:00" (24 hour time) to "6:00 PM" (12 hour time)
    const hours = parseInt(time.split(":")[0]);
    const minutes = time.split(":")[1];
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    time = `${formattedHours}:${minutes} ${period}`;

    // Convert date from "YYYY-MM-DD" to "Month DD, YYYY"
    const [year, month, day] = date.split("-");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const formattedDate = `${monthNames[parseInt(month) - 1]} ${parseInt(
      day
    )}, ${year}`;

    // determine if imgKey has a nonnull property called "value", if so, use that value, otherwise if imageKey is a nonnull string, use that value, otherwise use "main/medium_beach_volleyball_group_20240506a.jpeg"
    const imgKeyValue =
      imgKey.value ||
      imgKey ||
      "main/medium_beach_volleyball_group_20240506a.jpeg";

    const formData = {
      title,
      date: formattedDate,
      time,
      location: membersOnly ? "join group for location" : location,
      description,
      length: length === 1 ? "1hr" : length + " hrs",
      groupMeChatUrl: groupMeChatUrl || "none",
      imgKey: imgKeyValue,
      groupMeChatId: groupMeChatId || "none",
      chat: chat || "none",
      groupmeImg: groupmeImg || "none",
      password:
        hostName || yourName || yourPhoneNumber
          ? "host: " +
            hostName +
            " - submitted by: " +
            yourName +
            " - " +
            yourPhoneNumber +
            " - " +
            password
          : password,
      generalpublic: generalPublic,
      privateLocation: location,
      host1: "1705612509309",
      host2: "none",
      pollPrivateLocation,
      pollText,
    };
    console.log(formData);

    // Send POST request
    const response = await fetch(
      "https://4cljs7mcdi.execute-api.us-east-1.amazonaws.com/default/socialevents",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    if (response.ok) {
      setShowSuccessMessage(true);
      setTimeout(() => setShowSuccessMessage(false), 3000); // Hide after 3 seconds
    } else {
      console.error("Failed to create event");
    }
  };

  const mockLocations = [
    "Jarboe Park, Neptune Beach",
    "Margaritaville, Jacksonville Beach",
    "Veterans Park, St Johns",
    "K1 Speed, Jacksonville",
    "Fort Family Park, Jacksonville",
  ];

  return (
    <div className="create-event-page">
      <header className="header">
        <button className="back-button" onClick={() => window.history.back()}>
          Back
        </button>
        <h1>Create Event</h1>
      </header>
      <main className="content">
        {showSuccessMessage ? (
          <div className="success-message">
            <span className="large-checkmark">✔</span>
            <span className="success-message-text">
              Event Created Successfully
            </span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="event-form">
            <div className="form-item">
              <label className="custom-label">Copy from Previous Event</label>
              <select
                className="custom-select"
                onChange={(e) => handleEventSelect(e.target.value)}
              >
                {previousEvents.map((event) => (
                  <option key={event.socialEventId} value={event.socialEventId}>
                    {event.socialEventId}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-item">
              <label className="custom-label">Event Title</label>
              <input
                type="text"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                  setPollText(
                    e.target.value ? e.target.value.slice(0, 15) : null
                  );
                }}
                required
                className="custom-input"
              />
            </div>

            <div className="form-item">
              <label className="custom-label">Date & Time</label>
              <input
                type="datetime-local"
                value={dateTime}
                onChange={(e) => setDateTime(e.target.value)}
                step="900" // 15 minutes in seconds
                className="custom-input"
                required
              />
            </div>

            <div className="form-item">
              <label className="custom-label">Length (hours)</label>
              <input
                type="number"
                value={length}
                onChange={(e) => setLength(e.target.value)}
                required
                className="custom-input"
              />
            </div>

            <div className="form-item">
              <label className="custom-label">Location</label>
              <input
                type="text"
                value={location}
                onChange={(e) => {
                  setLocation(e.target.value);
                  setPollPrivateLocation(
                    e.target.value ? e.target.value.slice(0, 15) : null
                  );
                }}
                placeholder="Select or enter a location"
                className="custom-input"
                required
              />
              <button
                className="choose-button"
                type="button"
                onClick={() => setShowLocationModal(true)}
              >
                Choose Location
              </button>
            </div>

            <div className="form-item">
              <label className="custom-label">Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={4}
                className="custom-input"
                required
              />
            </div>

            <div className="form-item">
              <button
                type="button"
                className="toggle-advanced-button"
                onClick={() => setShowAdvancedFields(!showAdvancedFields)}
              >
                {showAdvancedFields ? "Hide Advanced Fields" : "Show Advanced Fields"}
              </button>
            </div>

            {showAdvancedFields && (
              <>
                {/* host name */}
                <div className="form-item">
                  <label className="custom-label">Host Name</label>
                  <span className="sub-label">(who should host this event)</span>
                  <input
                    type="text"
                    value={hostName}
                    onChange={(e) => setHostName(e.target.value)}
                    className="custom-input"
                  />
                </div>

                {/* your name */}
                <div className="form-item">
                  <label className="custom-label">Your Full Name</label>
                  <span className="sub-label">
                    (*first name will only be shared if you are the host)
                  </span>
                  <input
                    type="text"
                    value={yourName}
                    onChange={(e) => setYourName(e.target.value)}
                    className="custom-input"
                  />
                </div>

                {/* your phone number */}
                <div className="form-item">
                  <label className="custom-label">Your Phone Number</label>
                  <span className="sub-label">(*not shared publicly)</span>
                  <input
                    type="text"
                    value={yourPhoneNumber}
                    onChange={(e) => setYourPhoneNumber(e.target.value)}
                    className="custom-input"
                  />
                </div>

                <div className="form-item">
                  <label className="custom-label">Host ID Number</label>
                  <span className="sub-label">(enter 0 if you dont have one)</span>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="custom-input"
                  />
                </div>

                <div className="form-item">
                  <label className="custom-label">Public Invitation</label>
                  <span className="sub-label">
                    ("yes" if for entire group, "no" if for your close friends)
                  </span>
                  <select
                    value={generalPublic}
                    onChange={(e) => setGeneralPublic(e.target.value === "true")}
                    className="custom-input"
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>

                <div className="form-item">
                  <label className="custom-label">Members Only</label>
                  <span className="sub-label">
                    ("yes" for group members only, "no" for everyone)
                  </span>
                  <select
                    value={membersOnly}
                    onChange={(e) => setMembersOnly(e.target.value === "true")}
                    className="custom-input"
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>

                <div className="form-item">
                  <label className="custom-label">Short Location</label>

                  <span className="sub-label">
                    (short location for poll, max 3 words, not the full address)
                  </span>
                  <input
                    type="text"
                    value={pollPrivateLocation}
                    onChange={(e) => setPollPrivateLocation(e.target.value)}
                    className="custom-input"
                  />
                </div>

                <div className="form-item">
                  <label className="custom-label">Short Title</label>
                  <span className="sub-label">
                    (a short title for the event to use in the poll)
                  </span>
                  <input
                    type="text"
                    value={pollText}
                    onChange={(e) => setPollText(e.target.value)}
                    className="custom-input"
                  />
                </div>

                {/* chat */}
                <div className="form-item">
                  <label className="custom-label">Chat Group</label>
                  <select
                    value={chat}
                    onChange={(e) => setChat(e.target.value)}
                    className="custom-select"
                  >
                    <option value="">Select Chat Group</option>
                    {chatOptions.map((option, index) => (
                      <option key={index} value={option.value}>
                        {option.alias}
                      </option>
                    ))}
                  </select>
                </div>

                {/* groupme img */}
                <div className="form-item">
                  <label className="custom-label">Event Image on GroupMe</label>
                  <select
                    value={groupmeImg}
                    onChange={(e) => setGroupmeImg(e.target.value)}
                    className="custom-select"
                  >
                    <option value="">Select Image</option>
                    {groupMeImageOptions.map((option, index) => (
                      <option key={index} value={option.path}>
                        {option.alias}
                      </option>
                    ))}
                  </select>
                </div>

                {/* website image */}
                <div className="form-item">
                  <label className="custom-label">Event Image on Website</label>
                  <EventImagePicker
                    value={imgKey}
                    onChange={setImgKey}
                    legacyOptions={LEGACY_IMAGE_OPTIONS}
                  />
                </div>
              </>
            )}

            <button type="submit" className="submit-button">
              Create Event
            </button>
          </form>
        )}

        {showLocationModal && (
          <div className="modal">
            <div className="modal-content">
              <header className="modal-header">
                <h2>Select Location</h2>
                <button onClick={() => setShowLocationModal(false)}>
                  Close
                </button>
              </header>
              <div className="modal-body">
                <input
                  type="text"
                  value={locationSearch}
                  onChange={(e) => setLocationSearch(e.target.value)}
                  placeholder="Search for a location"
                />
                <ul>
                  {(() => {
                    const trimmed = (locationSearch || "").trim();
                    // Map API results into the legacy {value, alias} shape so
                    // setLocation / setPollPrivateLocation continue to receive
                    // the same payload they always have.
                    // The server returns favorites-first already, but we
                    // re-sort defensively so the popup renders favorites at
                    // the top even if the server contract changes. The
                    // selection callback contract — `{value, alias}` — is
                    // unchanged; `favorite` is purely cosmetic here.
                    const apiSorted = [...(apiLocations || [])].sort(
                      (a, b) => (b?.favorite ? 1 : 0) - (a?.favorite ? 1 : 0)
                    );
                    const apiMapped = apiSorted.map((r) => ({
                      value: `${r.title || ""}${
                        r.address ? ", " + r.address : ""
                      }`,
                      alias: r.title || "",
                      favorite: !!r.favorite,
                    }));
                    const legacyFiltered = locationOptions.filter((loc) =>
                      loc.alias
                        .toLowerCase()
                        .includes(locationSearch.toLowerCase())
                    );
                    // API hits → use them.
                    if (apiMapped.length > 0) {
                      return apiMapped.map((loc, index) => (
                        <li
                          key={`api-${index}`}
                          onClick={() => {
                            setLocation(loc.value);
                            setPollPrivateLocation(loc.alias);
                            setShowLocationModal(false);
                          }}
                        >
                          {loc.favorite ? (
                            <span
                              style={{
                                color: "#f5a623",
                                marginRight: 6,
                              }}
                              aria-label="Favorite"
                              title="Favorite"
                            >
                              ★
                            </span>
                          ) : null}
                          {loc.alias}
                        </li>
                      ));
                    }
                    // No API hits and the user typed something → show
                    // "No matches" placeholder above the legacy list so legacy
                    // options remain reachable.
                    return (
                      <>
                        {trimmed.length > 0 && (
                          <li
                            style={{
                              fontStyle: "italic",
                              color: "#6b7280",
                              cursor: "default",
                            }}
                          >
                            No matches
                          </li>
                        )}
                        {legacyFiltered.map((loc, index) => (
                          <li
                            key={`legacy-${index}`}
                            onClick={() => {
                              setLocation(loc.value);
                              setPollPrivateLocation(loc.alias);
                              setShowLocationModal(false);
                            }}
                          >
                            {loc.alias}
                          </li>
                        ))}
                      </>
                    );
                  })()}
                </ul>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default CreateEvent;
